export const BRAND_NAME = 'Betterbetke';
// Note: It is the main site url. Ex - krishna365.com, etc.
export const BRAND_DOMAIN = 'betterbet.ke';
// Note: It is the main site url. Ex - krishna365.com, etc.
export const BRAND_DOMAIN_SKIN_URL = 'betterbet.ke';
export const PROVIDER = 'BetFair';
export const PROVIDER_ID = 'BetFair';
export const BACKEND_DOMAIN = 'krna79.com';